import React, { Component } from 'react'
import get from 'lodash/get'
import scrollBy from '../scrollBy'
import Link from 'gatsby-link'
import Events from '../components/Events'
import Header from '../components/header/Header'
import MenuItem from '../components/header/menu/MenuItem'
import Aktuelles from '../components/Aktuelles'
import Organization from '../components/Organization'
import Donations from '../components/Donations'
import Contact from '../components/contact/Contact'

class IndexPage extends Component {
  handleScrollToElement(refName) {
    console.log(this.refs)
    const node = get(this.refs, refName)
    if (typeof window !== 'undefined') {
      scrollBy(node.offsetTop, 300)
    }
  }
  render() {
    let events = get(this, 'props.data.allMarkdownRemark.edges')
    const nextEventLink = events[0].node.fields.slug
    const nextEventDescription = `${events[0].node.frontmatter.displayDate} <br/> ${
      events[0].node.frontmatter.title
    }`
    return (
      <div>
        <Header
          nextEventLink={nextEventLink}
          nextEventDescription={nextEventDescription}
        >
          <MenuItem onClick={() => this.handleScrollToElement('aktuelles')}>
            Neuigkeiten
          </MenuItem>
          <MenuItem onClick={() => this.handleScrollToElement('organization')}>
            Über uns
          </MenuItem>
          <MenuItem onClick={() => this.handleScrollToElement('events')}>
            Termine
          </MenuItem>
          <MenuItem onClick={() => this.handleScrollToElement('donations')}>
            Spenden
          </MenuItem>
          <MenuItem onClick={() => this.handleScrollToElement('contact')}>
            Kontakt
          </MenuItem>
          <Link to="/imprint" style={{ color: 'inherit' }}>
            <MenuItem>Impressum</MenuItem>
          </Link>
          <Link to="/gdpr" style={{ color: 'inherit' }}>
            <MenuItem>Datenschutz</MenuItem>
          </Link>
        </Header>
        <div ref="aktuelles">
          <Aktuelles />
        </div>
        <div ref="organization">
          <Organization />
        </div>
        <div ref="events">
          <Events ref="events" events={events} />
        </div>
        <div ref="donations">
          <Donations ref="donations" />
        </div>
        <div ref="contact">
          <Contact ref="contact" />
        </div>
      </div>
    )
  }
}

export default IndexPage

export const query = graphql`
  query Query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: ASC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            title
            description
            date(formatString: "MMMM DD, YYYY")
            displayDate
            location
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js